import { apiClient, TASKS, WEBSITE_TASKS } from '../../../shared/api';

const FILTER_PARAMS = [
  { filterType: 'assignees', urlParam: 'with_assignees' },
  { filterType: 'creators', urlParam: 'creator_id_in' },
  { filterType: 'priorities', urlParam: 'with_priorities' },
  { filterType: 'statuses', urlParam: 'task_status_id_in' },
  { filterType: 'tags', urlParam: 'with_tags' },
];

const INCLUDE_PARAMS = 'assignee,case_file,tags,task_status';

const buildFilterParams = ({ activeFilters, searchQuery, taskStatusId }) => {
  const filter = {};

  if (searchQuery) {
    filter.name_cont = searchQuery;
  }

  if (taskStatusId) {
    filter.task_status_id_in = taskStatusId;
  }

  FILTER_PARAMS.forEach(({ filterType, urlParam }) => {
    if (activeFilters[filterType].length > 0) {
      filter[urlParam] = activeFilters[filterType].join(',');
    }
  });

  return Object.keys(filter).length > 0 ? { filter } : {};
};

const buildPaginationParams = (page, perPage) => {
  if (!page || !perPage) return {};

  return {
    page: {
      number: page,
      size: perPage,
    },
  };
};

export const createTask = async (taskData) => {
  const { assigneeId, caseFileId, name, notes, priority, tagIds, taskStatusId } =
    taskData;

  const requestBody = {
    task: {
      assignee_id: assigneeId,
      case_file_id: caseFileId,
      name,
      notes,
      priority,
      tag_ids: tagIds,
      task_status_id: taskStatusId,
    },
  };

  const params = {
    include: INCLUDE_PARAMS,
  };

  const response = await apiClient.post(WEBSITE_TASKS(), requestBody, {
    params,
  });

  return response.data;
};

export const deleteTask = async (taskId) => {
  await apiClient.delete(`${TASKS}/${taskId}`);
};

export const fetchTasks = async ({
  activeFilters,
  page,
  perPage,
  searchQuery,
  taskStatusId,
}) => {
  const params = {
    include: INCLUDE_PARAMS,
    ...buildFilterParams({ activeFilters, searchQuery, taskStatusId }),
    ...buildPaginationParams(page, perPage),
  };

  const response = await apiClient.get(WEBSITE_TASKS(), { params });

  return response.data;
};

export const updateTask = async ({ taskData, taskId }) => {
  const { assigneeId, caseFileId, name, notes, priority, tagIds, taskStatusId } =
    taskData;

  const requestBody = {
    task: {
      assignee_id: assigneeId,
      case_file_id: caseFileId,
      name,
      notes,
      priority,
      tag_ids: tagIds,
      task_status_id: taskStatusId,
    },
  };

  const params = {
    include: INCLUDE_PARAMS,
  };

  const response = await apiClient.patch(`${TASKS}/${taskId}`, requestBody, {
    params,
  });

  return response.data;
};
